const formatPassage = ({ book, chapter, startVerse, endVerse }) => {
  return `${book} ${chapter}${startVerse ? `:${startVerse}` : ''}${
    endVerse ? `-${endVerse}` : ''
  }`;
};

export default formatPassage;
